var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { Component } from 'react';
import { Icon } from "../../UI";
import { t, Translate } from "../../I18N";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";
import { exportDocuments } from "../actions/exportActions";

import Modal from "../../Layout/Modal";

import { Captcha, FormGroup } from "../../ReactReduxForms";

import { LocalForm } from "../../Forms/Form";










class ExportButton extends Component {


  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
    this.export = this.export.bind(this);
    this.showModal = this.showModal.bind(this);
    this.exportWithCaptcha = this.exportWithCaptcha.bind(this);
  }

  export() {
    if (!this.props.processing) {
      this.props.exportDocuments(this.props.storeKey);
    }
  }

  exportWithCaptcha(values) {
    if (!this.props.processing) {
      this.props.exportDocuments(this.props.storeKey, values.captcha);
    }
    this.setState({ modal: false });
  }

  showModal() {
    this.setState({ modal: true });
  }

  render() {
    let btnClassName = 'btn btn-default btn-export';
    btnClassName += this.props.processing ? ' btn-disabled' : '';
    btnClassName += ` ${this.props.className}`;
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.user.get('_id') ? this.export : this.showModal,
        className: btnClassName }, void 0,

      !this.props.processing ? /*#__PURE__*/
      _jsx(Icon, { icon: "export-csv", transform: "up-0.1" }) : /*#__PURE__*/

      _jsx(Icon, { icon: "spinner", spin: true }), /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Export CSV'))
      ),
      this.state.modal && /*#__PURE__*/
      _jsx(Modal, { isOpen: true, type: "export" }, void 0, /*#__PURE__*/
      _jsx(LocalForm, {
        onSubmit: this.exportWithCaptcha,
        validators: { captcha: { required: (val) => val && val.text.length } } }, void 0, /*#__PURE__*/

      _jsx(FormGroup, { model: ".captcha" }, "captcha", /*#__PURE__*/
      _jsx("h3", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Exporting entities to CSV")
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Please type in letters and numbers from the image to start the export."

      )
      ), /*#__PURE__*/
      _jsx(Captcha, { remote: false, model: ".captcha" })
      ), /*#__PURE__*/
      _jsx("div", { className: "buttons" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "button",
        className: "btn",
        onClick: () => {
          this.setState({ modal: false });
        },
        value: "Cancel" }
      ), /*#__PURE__*/
      _jsx("input", { type: "submit", className: "btn btn-success", value: "Export" })
      )
      )
      )

      ));

  }
}_defineProperty(ExportButton, "defaultProps", void 0);

ExportButton.defaultProps = {
  className: ''
};

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({ exportDocuments }, wrapDispatch(dispatch, props.storeKey));
}

function mapStateToProps(state) {
  return {
    processing: state.exportSearchResults.exportSearchResultsProcessing,
    user: state.user
  };
}



export default connect(mapStateToProps, mapDispatchToProps)(ExportButton);